import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration
// Replace with your Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyCtaftgrL4p4wqNC2w211mUi8amkjw2kzM",
    authDomain: "profstudymate-6d0fc.firebaseapp.com",
    databaseURL: "https://profstudymate-default-rtdb.firebaseio.com",
    projectId: "profstudymate",
    storageBucket: "profstudymate.appspot.com",
    messagingSenderId: "141453158869",
    appId: "1:141453158869:web:d4ded426a90e9937e2f55c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
